// extracted by mini-css-extract-plugin
export var category = "OfficeCard-module--category--00f10";
export var categoryIcon = "OfficeCard-module--categoryIcon--387ce";
export var description = "OfficeCard-module--description--66925";
export var link = "OfficeCard-module--link--2416c";
export var title = "OfficeCard-module--title--6ec1f";
export var wrapper = "OfficeCard-module--wrapper--c9133";